// extracted by mini-css-extract-plugin
module.exports = {"container":"Link-container-2fd_-","bold":"Link-bold-2dHvQ","colorWhite":"Link-colorWhite-35NOZ","colorBlack":"Link-colorBlack-sfhzD"};